export type UrgentPaymentWorkflowStatus = "not_required" | "pending" | "done";

export const getUrgentPaymentWorkflowStatus = (input: {
  is_urgent_sourcing_request?: boolean | number | null;
  urgent_payment_done?: number | null;
}): UrgentPaymentWorkflowStatus => {
  if (!Boolean(Number(input.is_urgent_sourcing_request))) {
    return "not_required";
  }

  return Number(input.urgent_payment_done) === 1 ? "done" : "pending";
};

export const formatUrgentPaymentYesLabel = (
  percentage?: number | string | null,
): string => {
  if (percentage != null && !Number.isNaN(Number(percentage))) {
    return `Yes(${percentage}%)`;
  }
  return "Yes";
};
